import React, { Component, Fragment } from 'react'
import { View, Dimensions, Platform } from 'react-native'
import Slider from 'react-native-slider'
import styled from 'styled-components/native'

import Radio from '../../Atoms/Radio'
import TranslatedText from '../../Atoms/TranslatedText'
import PageHeader from '../../Molecules/PageHeader'
import BusinessItem from '../../Organisms/BusinessItem'

import theme from '../../../styles/theme'

import { translate } from '../../../services/translate'

const sliderHeight = 40

const screenheight = () => Dimensions.get('window').height

const { statusBarHeight, teamBarHeight, headerHeight, paginationHeight, businesses: { titleHeight, labelHeight } } = theme

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const BusinessContainer = styled(View)`
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${theme.colours.lightgrey};
`

const BusinessItemContainer = styled(View)`
  height: 100%;
  width: ${props => 100 / props.numberOfItems}%;
`

const BusinessItemsContainer = styled(View)`
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-left: ${labelHeight}px;
`

// I know this is horrible, but rotates and RN dont play nice together
const LabelContainer = styled(View)`
  position: absolute;
  top: ${props => (screenheight() - headerHeight - teamBarHeight - statusBarHeight - labelHeight + titleHeight - paginationHeight) / 2}px;
  left: -${props => (screenheight() - headerHeight - teamBarHeight - statusBarHeight - titleHeight - paginationHeight - labelHeight) / 2}px;
  flex-direction: row;
  width: ${props => screenheight() - headerHeight - teamBarHeight - statusBarHeight - titleHeight - paginationHeight}px;
  height: ${labelHeight}px;
  align-items: center;
  justify-content: space-around;
  transform: rotate(-90deg);
`

const Price1Container = styled(View)`
  width: ${props => (props.height - theme.businesses.titleHeight) / 15 * 8}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: ${2 * theme.gutterUnit}px;
  padding-right: ${theme.gutterUnit}px;
`

const Price2Container = styled(View)`
  width: ${props => (props.height - theme.businesses.titleHeight) / 15 * 7}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: ${4 * theme.gutterUnit}px;
  padding-right: ${theme.gutterUnit}px;
`

const Slider1Container = styled(View)`
  position: absolute;
  width: ${props => props.width - (theme.gutterUnit * 4)}px;
  top: ${props => (props.height / 15) * 8 - (theme.gutterUnit)}px;
  height: ${sliderHeight}px;
`

const Slider2Container = styled(View)`
  position: absolute;
  width: ${props => props.width - (theme.gutterUnit * 4)}px;
  height: ${sliderHeight}px;
  bottom: 0;
`

const AbsoluteRadioContainer = styled(View)`
  position: absolute;
  height: 40px;
  bottom: 0;
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  z-index: 2;
  display: flex;
`

const RadioContainer = styled(View)`
  width: ${props => props.width}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-right: ${Platform.select({ web: '20px', default: 0 })};
`

const Spacer = styled(View)`
  width: ${Platform.select({ web: 4.5, default: 3 }) * theme.gutterUnit}px;
`

export default class BusinessesPage1 extends Component {
  constructor (props) {
    super(props)
    this.state = { dimensions: null }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (!nextProps.active) {
      return false
    }
    if (nextProps.active && !this.props.active) {
      return true
    }
    if (this.state.dimensions === null && nextState.dimensions !== null) {
      return true
    }
    if (this.state.dimensions && this.state.dimensions.width && nextState.dimensions && nextState.dimensions.width && (this.state.dimensions.width !== nextState.dimensions.width)) {
      return true
    }
    if (this.state.dimensions && this.state.dimensions.height && nextState.dimensions && nextState.dimensions.height && (this.state.dimensions.height !== nextState.dimensions.height)) {
      return true
    }
    if (nextProps.selectedBusiness !== this.props.selectedBusiness) {
      return true
    }
    if (nextProps.decisions !== this.props.decisions) {
      return true
    }
    if (nextProps.items !== this.props.items) {
      return true
    }
    if (nextProps.enableChanges !== this.props.enableChanges) {
      return true
    }
    return false
  }

  handleLayout = event => {
    const { width, height } = event.nativeEvent.layout
    if (this.state.dimensions && this.state.dimensions.width === width && this.state.dimensions.height === height) return // layout was already called
    this.setState({
      dimensions: { width, height }
    })
  }

  render () {
    const { items, selectedBusiness, onBusinessSelect, decisions, onChangeValue, enableChanges } = this.props
    const selectedItem = items.find(it => it.type === selectedBusiness)
    const shouldShowRadio = enableChanges && selectedItem && ['WEALTH_MANAGEMENT', 'BUSINESS_LOANS'].includes(selectedItem.type)
    const widthPerBusiness = this.state.dimensions ? (this.state.dimensions.width) / items.length : 0

    return (
      <Container>
        <PageHeader text={translate('businessDecisions.screen1.screenHeader', 'BUSINESS DECISIONS').toUpperCase()} />
        <BusinessContainer>
          <BusinessItemsContainer onLayout={this.handleLayout}>
            {this.state.dimensions && items.map((item, itemIndex) => {
              return (
                <Fragment key={item.type}>
                  {shouldShowRadio && item.type === selectedBusiness && (
                    <AbsoluteRadioContainer>
                      <RadioContainer style={{ marginLeft: widthPerBusiness * itemIndex }} numberOfItems={items.length} width={widthPerBusiness}>
                        <Radio isChecked={decisions[selectedBusiness].price2Now === -1} onClick={e => onChangeValue(selectedBusiness, 'price2Now', -1)} />
                        <Spacer />
                        <Radio isChecked={decisions[selectedBusiness].price2Now === 0} onClick={e => onChangeValue(selectedBusiness, 'price2Now', 0)} />
                        <Spacer />
                        <Radio isChecked={decisions[selectedBusiness].price2Now === 1} onClick={e => onChangeValue(selectedBusiness, 'price2Now', 1)} />
                      </RadioContainer>
                    </AbsoluteRadioContainer>
                  )}
                  <BusinessItemContainer numberOfItems={items.length}>
                    <BusinessItem
                      item={item}
                      active={item.type === selectedBusiness}
                      onPress={() => { onBusinessSelect(item.type) }}
                      decisions={decisions[item.type]}
                      height={this.state.dimensions.height}
                    />
                  </BusinessItemContainer>
                </Fragment>
              )
            })}
            {enableChanges && this.state.dimensions && selectedItem && (
              <Slider1Container height={this.state.dimensions.height} width={this.state.dimensions.width}>
                <Slider
                  key={selectedBusiness}
                  value={decisions[selectedBusiness].price1Now}
                  onValueChange={value => onChangeValue(selectedBusiness, 'price1Now', value)}
                  minimumValue={selectedItem.slider1Min}
                  maximumValue={selectedItem.slider1Max}
                  minimumTrackTintColor={theme.colours.blue}
                  maximumTrackTintColor={theme.colours.grey}
                  thumbTintColor={theme.colours.blue}
                  step={1}
                />
              </Slider1Container>
            )}
            {enableChanges && this.state.dimensions && selectedItem && (
              <Slider2Container width={this.state.dimensions.width}>
                {!shouldShowRadio && (
                  <Slider
                    key={selectedBusiness}
                    value={decisions[selectedBusiness].price2Now}
                    onValueChange={value => onChangeValue(selectedBusiness, 'price2Now', value)}
                    minimumValue={selectedItem.slider2Min}
                    maximumValue={selectedItem.slider2Max}
                    minimumTrackTintColor={theme.colours.blue}
                    maximumTrackTintColor={theme.colours.grey}
                    thumbTintColor={theme.colours.blue}
                    step={1}
                  />
                )}
              </Slider2Container>
            )}
          </BusinessItemsContainer>
          {this.state.dimensions && (
            <LabelContainer>
              <Price2Container height={this.state.dimensions.height}>
                <TranslatedText medium size='xs' uppercase value='businessDecisions.screen1.label_now' default='NOW' />
                <TranslatedText medium size='l' uppercase value='businessDecisions.screen1.label_other' default='OTHER' />
                <TranslatedText medium darkgrey size='xs' uppercase value='businessDecisions.screen1.label_prev' default='PREV' />
              </Price2Container>
              <Price1Container height={this.state.dimensions.height}>
                <TranslatedText medium size='xs' uppercase value='businessDecisions.screen1.label_now' default='NOW' />
                <TranslatedText medium size='l' uppercase value='businessDecisions.screen1.label_price' default='PRICE' />
                <TranslatedText medium darkgrey size='xs' uppercase value='businessDecisions.screen1.label_prev' default='PREV' />
              </Price1Container>
            </LabelContainer>
          )}
        </BusinessContainer>
      </Container>
    )
  }
}
